export * from './shadow-type-2.component';